import React from "react";
import DemoPage from "@/components/DemoPage";

const DemoInsuranceEnrollment = () => (
  <DemoPage
    seo={{
      title: "Insurance Enrollment Demo | Hewto.ai",
      description:
        "Watch Hewto.ai capture, validate, and structure data from insurance enrollment forms in real time. Book a personalized demo on your own enrollment documents.",
      keywords:
        "insurance enrollment automation, enrollment form ocr, insurance enrollment data extraction, healthcare document ai demo, enrollment document processing",
      canonical: "https://www.hewto.ai/demo/insurance-enrollment",
    }}
    heading="Insurance Enrollment Demo"
    intro="See Hewto.ai automate insurance enrollment intake. Our AI captures, validates, and organizes data from enrollment forms instantly — faster, smarter, and error-free."
    videoId="Lno5PcBxfDE"
    videoTitle="Hewto.ai — Insurance Enrollment demo"
    source="demo_insurance_enrollment"
  />
);

export default DemoInsuranceEnrollment;
